import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

export default function AdminDashboard() {
  const menuUrl = `${window.location.origin}/menu`;

  return (
    <div className="max-w-4xl mx-auto">
      <h1 className="text-3xl font-serif text-blue-900 font-bold mb-8">Dashboard</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100">
          <h2 className="text-xl font-semibold mb-4">Código QR del Menú</h2>
          <p className="text-slate-600 mb-6">Comparte este código QR con tus clientes para que puedan ver los menús desde sus teléfonos.</p>
          <div className="flex flex-col items-center justify-center p-6 bg-slate-50 rounded-xl border border-dashed border-slate-200">
            <QRCodeSVG value={menuUrl} size={200} bgColor={"#ffffff"} fgColor={"#1E3A8A"} level={"L"} />
            <a href={menuUrl} target="_blank" rel="noreferrer" className="mt-4 text-orange-600 font-medium hover:underline text-center break-all">
              {menuUrl}
            </a>
          </div>
        </div>

        <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100">
          <h2 className="text-xl font-semibold mb-4">Atajos</h2>
          <div className="space-y-3">
            <a href="/admin/menus" className="block p-4 rounded-xl border border-slate-100 hover:border-orange-200 hover:bg-orange-50 transition-colors">
              <span className="font-semibold text-slate-800">Gestionar Menús</span>
              <p className="text-sm text-slate-500 mt-1">Añadir o editar los platillos de tu catering.</p>
            </a>
            <a href="/admin/settings" className="block p-4 rounded-xl border border-slate-100 hover:border-blue-200 hover:bg-blue-50 transition-colors">
              <span className="font-semibold text-slate-800">Configuración del Sitio</span>
              <p className="text-sm text-slate-500 mt-1">Cambiar la foto principal, descripción y contacto.</p>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
